import Ready from 'document-ready';

import 'modern-css-reset';
import './css/style.css';
import initSlider from './slider';

Ready(() => {
  const slider = document.querySelector('.slider');
  if (slider) {
    initSlider(slider);
  }

  const menu = document.getElementById('menu');
  const nav = document.querySelector('#header nav');
  if (!menu || !nav) {
    return;
  }
  menu.addEventListener('click', () => {
    const hidden = window.getComputedStyle(nav).display === 'none';
    nav.style.display = hidden ? 'flex' : 'none';
  });
});
